import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "flash-cards" */ './FlashCardsPage'));

export const MCATDailyFlashCardsPage = Loadable(
  () => import(/* webpackChunkName: "flash-cards" */ './MCATDailyFlashCardsPage'),
);
